import React from 'react';

const Footer = () => {
  return (
    <div id="footer" style={{ background: '#34495e', color: '#fff', paddingTop: '80px', paddingBottom: '40px' }}>

      <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 40px' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: '60px',
          marginBottom: '60px',
          alignItems: 'start'
        }}>
          {/* Logo and Follow Us Section */}
          <div style={{ textAlign: 'center' }}>
            <img 
              src="/images/logos/Logo.png" 
              alt="The Midnight Edits" 
              style={{ 
                width: '270px', 
                marginBottom: '35px',
                display: 'block',
                marginLeft: 'auto',
                marginRight: 'auto'
              }} 
            />
            <h3 style={{
              fontSize: '14px',
              fontWeight: '700',
              letterSpacing: '3px',
              textTransform: 'uppercase',
              marginBottom: '30px',
              color: '#fff',
              fontFamily: 'inherit'
            }}>Follow Us</h3>
            <div style={{ 
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: '12px',
              maxWidth: '180px',
              margin: '0 auto'
            }}>
              {/* Facebook */}
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" 
                aria-label="Facebook"
                style={{
                width: '50px',
                height: '50px',
                borderRadius: '50%',
                background: '#3b5998',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#fff',
                fontSize: '20px',
                fontWeight: 'bold',
                textDecoration: 'none',
                transition: 'all 0.3s ease',
                fontFamily: 'Arial, sans-serif'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 8px 20px rgba(59, 89, 152, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
              >f</a>
              
              {/* Instagram */}
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer"
                aria-label="Instagram"
                style={{
                width: '50px',
                height: '50px',
                borderRadius: '50%',
                background: 'linear-gradient(45deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#fff',
                fontSize: '24px',
                textDecoration: 'none',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 8px 20px rgba(188, 24, 136, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
              
              {/* YouTube */}
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer"
                aria-label="YouTube"
                style={{
                width: '50px',
                height: '50px',
                borderRadius: '50%',
                background: '#ff0000',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#fff',
                fontSize: '18px',
                fontWeight: 'bold',
                textDecoration: 'none',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 8px 20px rgba(255, 0, 0, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
              >▶</a>
              
              {/* Twitter/X */}
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer"
                aria-label="Twitter"
                style={{
                width: '50px',
                height: '50px',
                borderRadius: '50%',
                background: '#1DA1F2',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#fff',
                fontSize: '20px',
                fontWeight: 'bold',
                textDecoration: 'none',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 8px 20px rgba(29, 161, 242, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
              >𝕏</a>
              
              {/* Pinterest */}
              <a href="https://pinterest.com" target="_blank" rel="noopener noreferrer"
                aria-label="Pinterest"
                style={{
                width: '50px',
                height: '50px',
                borderRadius: '50%',
                background: '#E60023',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#fff',
                fontSize: '22px',
                fontWeight: 'bold',
                textDecoration: 'none',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 8px 20px rgba(230, 0, 35, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
              >P</a>
              
              {/* LinkedIn */}
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"
                aria-label="LinkedIn"
                style={{
                width: '50px',
                height: '50px',
                borderRadius: '50%',
                background: '#0077b5',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#fff',
                fontSize: '18px',
                fontWeight: 'bold',
                textDecoration: 'none',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 119, 181, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
              >in</a>
            </div>
          </div>

          {/* Quick Links */}
          <div style={{ textAlign: 'center' }}>
            <h3 style={{
              fontSize: '14px',
              fontWeight: '700',
              letterSpacing: '3px',
              textTransform: 'uppercase',
              marginBottom: '30px',
              color: '#fff',
              fontFamily: 'inherit'
            }}>Quick Links</h3>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li style={{ marginBottom: '18px' }}>
                <a href="#contact" className="scroll" style={{
                  color: '#bdc3c7',
                  textDecoration: 'none',
                  fontSize: '15px',
                  transition: 'color 0.3s ease',
                  display: 'inline-block',
                  fontFamily: 'inherit'
                }}
                onMouseEnter={(e) => e.currentTarget.style.color = '#d4af37'}
                onMouseLeave={(e) => e.currentTarget.style.color = '#bdc3c7'}
                >Contact Us</a>
              </li>
              <li style={{ marginBottom: '18px' }}>
                <a href="#about" className="scroll" style={{
                  color: '#bdc3c7',
                  textDecoration: 'none',
                  fontSize: '15px',
                  transition: 'color 0.3s ease',
                  display: 'inline-block',
                  fontFamily: 'inherit'
                }}
                onMouseEnter={(e) => e.currentTarget.style.color = '#d4af37'}
                onMouseLeave={(e) => e.currentTarget.style.color = '#bdc3c7'}
                >About Us</a>
              </li>
              <li style={{ marginBottom: '18px' }}>
                <a href="#services" className="scroll" style={{
                  color: '#bdc3c7',
                  textDecoration: 'none',
                  fontSize: '15px',
                  transition: 'color 0.3s ease',
                  display: 'inline-block',
                  fontFamily: 'inherit'
                }}
                onMouseEnter={(e) => e.currentTarget.style.color = '#d4af37'}
                onMouseLeave={(e) => e.currentTarget.style.color = '#bdc3c7'}
                >Pricing</a>
              </li>
              <li style={{ marginBottom: '18px' }}>
                <a href="#blog" className="scroll" style={{
                  color: '#bdc3c7',
                  textDecoration: 'none',
                  fontSize: '15px',
                  transition: 'color 0.3s ease',
                  display: 'inline-block',
                  fontFamily: 'inherit'
                }}
                onMouseEnter={(e) => e.currentTarget.style.color = '#d4af37'}
                onMouseLeave={(e) => e.currentTarget.style.color = '#bdc3c7'}
                >Blog</a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div style={{ textAlign: 'center' }}>
            <h3 style={{
              fontSize: '14px',
              fontWeight: '700',
              letterSpacing: '3px',
              textTransform: 'uppercase',
              marginBottom: '30px',
              color: '#fff',
              fontFamily: 'inherit'
            }}>Services</h3>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li style={{ marginBottom: '18px', color: '#bdc3c7', fontSize: '15px', fontFamily: 'inherit' }}>Wedding Highlight Film</li>
              <li style={{ marginBottom: '18px', color: '#bdc3c7', fontSize: '15px', fontFamily: 'inherit' }}>Wedding Feature Film</li>
              <li style={{ marginBottom: '18px', color: '#bdc3c7', fontSize: '15px', fontFamily: 'inherit' }}>Wedding Highlight & Feature</li>
              <li style={{ marginBottom: '18px', color: '#bdc3c7', fontSize: '15px', fontFamily: 'inherit' }}>Others</li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div style={{
          borderTop: '1px solid rgba(255,255,255,0.1)',
          paddingTop: '30px',
          textAlign: 'center'
        }}>
          <p style={{
            color: '#95a5a6',
            fontSize: '13px',
            margin: '0 0 10px 0',
            letterSpacing: '1px',
            lineHeight: '1.6'
          }}>
            <span style={{ marginRight: '15px' }}>
              <span style={{ color: '#5dade2', marginRight: '5px' }}>●</span>
              EMAIL US: <a href="mailto:info@themidnightedits.com" style={{
                color: '#95a5a6',
                textDecoration: 'none'
              }}>info@themidnightedits.com</a>
            </span>
            <span>
              <span style={{ color: '#5dade2', marginRight: '5px' }}>©</span>
              {new Date().getFullYear()} The Midnight Edits - All rights reserved
            </span>
          </p>
          <p style={{
            color: '#95a5a6',
            fontSize: '13px',
            margin: 0,
            letterSpacing: '1px'
          }}>
            Where every frame tells a story
          </p>
        </div>
      </div>

      <style>{`
        @media only screen and (max-width: 959px) {
          #footer .container > div:first-child {
            grid-template-columns: 1fr !important;
            gap: 50px !important;
          }
        }

        @media only screen and (max-width: 480px) {
          #footer .container {
            padding: 0 20px !important;
          }

          #footer img {
            width: 140px !important;
          }

          #footer h3 {
            font-size: 12px !important;
          }

          #footer a[style*="width: 50px"] {
            width: 45px !important;
            height: 45px !important;
            font-size: 16px !important;
          }

          #footer div[style*="gridTemplateColumns: repeat(3, 1fr)"] {
            gap: 10px !important;
            max-width: 160px !important;
          }

          #footer p {
            font-size: 9px !important;
          }
        }
      `}</style>
    </div>
  );
};

export default Footer;
